import { render, staticRenderFns } from "./AdminPostGroupByPost.vue?vue&type=template&id=f5aadfce"
import script from "./AdminPostGroupByPost.vue?vue&type=script&lang=js"
export * from "./AdminPostGroupByPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports